import { AxiosError } from "axios"

const getValidationErrors = (error : AxiosError) => {
  let errData = error?.response?.data ?? []
  let ret : Array<string> = []

  if (errData instanceof Array) {
    errData.forEach((element) => {
      const { _, message } = element
      ret.push(message)
    })
  }

  return ret
}

export default getValidationErrors